export default __webpack_public_path__ + "static/media/eth.af9cb948.png";